import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AutoResetDonationFlow } from './-components/flows/auto-reset-donation-flow';
import { UpdatePortalOnConfirmedDonationFlow } from './-components/flows/update-portal-on-confirmed-donation-flow';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { lazy, Suspense } from 'react';

const StandaloneDonationsFlow = lazy(() =>
	import('./-components/flows/standalone-donations-flow').then((m) => ({ default: m.StandaloneDonationsFlow })),
);

export const Route = createFileRoute('/$portalId')({
	component: RouteComponent,
});

function RouteComponent() {
	const { iframe } = Route.useSearch();

	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<AutoResetDonationFlow />
				{iframe && (
					<Suspense>
						<StandaloneDonationsFlow />
					</Suspense>
				)}
				<UpdatePortalOnConfirmedDonationFlow />
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
